import { useEffect } from 'react';
import isEqual from 'lodash/isEqual';
import { useRouter } from 'next/router';

import { RouterEvents } from 'Types/generic';

import { PollingState } from '../DownloadCSV.types';
import { getQueryFromURL } from '../useDownloadCsvPolling/DownloadCSV.helpers';

export type AbortedPollingState = PollingState.AbortedPage | PollingState.AbortedFilter;

type UseDownloadCsvAbortPollingProps = {
	onAbortPolling: (abortedPollingState: AbortedPollingState) => void;
	state: PollingState;
};

export const useDownloadCsvAbortPolling = ({ onAbortPolling, state }: UseDownloadCsvAbortPollingProps): void => {
	const { asPath, events } = useRouter();
	const origin = typeof window !== 'undefined' ? window.location.origin : '';
	const pathname = origin ? new URL(asPath, origin).pathname : '';

	useEffect(() => {
		const abortPoolingOnRouteChange = (url: string) => {
			const prevQuery = getQueryFromURL(asPath);
			const currentQuery = getQueryFromURL(url);
			const isQueryChange = !isEqual(prevQuery, currentQuery);
			const newUrl = new URL(url, window.location.origin);
			const isPageChange = newUrl?.pathname !== pathname;

			if (state === PollingState.Polling && (isQueryChange || isPageChange)) {
				onAbortPolling(isPageChange ? PollingState.AbortedPage : PollingState.AbortedFilter);
			}
		};

		events.on(RouterEvents.ROUTE_CHANGE_START, abortPoolingOnRouteChange);

		return () => {
			events.off(RouterEvents.ROUTE_CHANGE_START, abortPoolingOnRouteChange);
		};
	}, [events, onAbortPolling, asPath, state, pathname]);
};
